import React, { useEffect, useState } from "react";
import Commongrid from "../../common/Commongrid";
import formatDateAndTime from "../../common/formatDateAndTime";
import { getCityName } from "../../api/api";
import commonapihandler from "../../common/commonapihandler";
import { useNavigate } from "react-router-dom";

function createData(
  id,
  source,
  bookingid,
  bookingstatus,
  startdate,
  enddate,
  city,
  amount,
) {
  return {
    id,
    source,
    bookingid,
    bookingstatus,
    startdate,
    enddate,
    city,
    amount,
  };
}

const Mybookings = ({ selectedRow }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  const bookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  delete bookingStatus?.inverted;
  const fleetBookingvalue = bookingStatus;
  const navigate = useNavigate();

  const filteredKeys = Object.keys(fleetBookingvalue).filter(
    (key) => !fleetBookingvalue[key].includes("Inquiry"),
  );
  const [totalCount, setTotalCount] = useState(0);
  const [bookingdetails, setBookingDetails] = useState([]);
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
  });
  const [vehicleId, setVehicleId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState({});

  const getCityNameAPI = async (id) => {
    const apiDetails = await getCityName(id);
    const response = await commonapihandler(
      apiDetails?.apiUrl,
      apiDetails?.method,
    );
    if (response) {
      setCities(response);
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "Id",
      minWidth: 100,
      align: "start",
      sortable: false,
    },
    {
      field: "source",
      headerName: "Source",
      minWidth: 150,
      align: "start",
      sortable: false,
    },
    {
      field: "bookingid",
      headerName: "Booking Id",
      minWidth: 250,
      align: "start",
      sortable: false,
    },
    {
      field: "bookingstatus",
      headerName: "Booking Status",
      minWidth: 200,
      align: "start",
      sortable: false,
    },
    {
      field: "startdate",
      headerName: "Start Date",
      minWidth: 200,
      align: "start",
    },
    {
      field: "enddate",
      headerName: "End Date",
      minWidth: 200,
      align: "start",
    },
    { field: "city", headerName: "City", minWidth: 180, align: "start" },
    { field: "amount", headerName: "Amount", minWidth: 100, align: "start" },
  ];

  const rows =
    (bookingdetails &&
      bookingdetails?.map((item) =>
        createData(
          item?.id,
          item?.source,
          item?.bookingCode,
          fleetBookingStatus[item?.bookingStatus],
          formatDateAndTime(item?.bookFrom),
          formatDateAndTime(item?.bookTo),
          cities[item?.cityId],
          "₹ " + item?.costToCustomer,
        ),
      )) ||
    [];

  const getVechileBookingListings = async (page = 0, pageSize = 20) => {
    if (!vehicleId) return;

    let query = "";

    if (filteredKeys?.length) {
      query += `&bookingStatus=[${filteredKeys}]`;
    }

    const limit = pageSize;
    const offset = page * pageSize;

    try {
      setLoading(true);

      const response = await fetch(
        `${apiUrl}/api/vehiclebookings?limit=${limit}&offset=${offset}&vehicleId=${vehicleId}${query}`,
        { method: "GET" },
      );

      const data = await response.json();

      if (data?.statusCode === "0100") {
        setBookingDetails(data?.entities?.rows || []);
        setTotalCount(data?.entities?.count || 0);
      }
    } catch (error) {
      console.error("Error fetching bookings:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedRow) {
      setVehicleId(selectedRow.id);
    }
    getCityNameAPI();
  }, [selectedRow]);

  useEffect(() => {
    if (vehicleId) {
      getVechileBookingListings(paginationModel.page, paginationModel.pageSize);
    }
  }, [vehicleId, paginationModel]);

  return (
    <>
      <Commongrid
        rows={rows}
        columns={columns}
        totalCount={totalCount} // total rows from API
        handleViewClick={(params) => {
          const navigate = `/viewallbookings?bookingid=${params?.bookingid}&id=${params?.id}&display=true`;
          window.open(navigate, "_blank");
        }}
        api={getVechileBookingListings}
        setPaginationModel={setPaginationModel}
        paginationModel={paginationModel}
        loading={loading}
        disableColumnMenu={false}
      />
    </>
  );
};

export default Mybookings;
